function setActiveStep(index) {
	const steps = document.querySelectorAll(".progressbar .step");
	const progressLines = document.querySelectorAll(
		".progressbar .progress-line",
	);

	steps.forEach((step, i) => {
		// Reset all status classes
		step.classList.remove("active", "completed");

		if (i === index) {
			step.classList.add("active");
		} else if (i < index) {
			step.classList.add("completed");
		}

		// Sync stepname active state
		const name = step.querySelector(".stepname");
		if (name) {
			if (i <= index) name.classList.add("active");
			else name.classList.remove("active");
		}

		// Sync progress-line active state
		const line = step.querySelector(".progress-line");
		if (line) {
			if (i < index) line.classList.add("active");
			else line.classList.remove("active");
		}
	});

	progressLines.forEach((step, i) => {
		// Reset all status classes
		step.classList.remove("active", "completed");

		if (i < index) {
			step.classList.add("active");
		}
	});
}
